<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousams" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <!-- <md-button
              @click="previousFFView"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
          ><md-icon icon="bell-fill" class="border rounded p-2">edit</md-icon></md-button>-->
          <b-navbar-brand center>Importer Security Filing(ISF)</b-navbar-brand>
        </b-navbar>
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button
              v-if="amsFiligModal.normalIsfId!=''"
              @click="downloadWord()"
              size="sm"
              variant="warning"
            >ISF Word</b-button>
          </b-nav-form>
        </b-navbar-nav>
        <banner-component
          :allModuleIdBanner="this.stuffingDataLiner[0].allModuleId"
          :jobSeriesBanner="this.stuffingDataLiner[0].ffExportFclSeries"
          :bannerClientName="
            this.getCLientData[0].clientName
          "
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter class="labelMargtop">
            
              <md-layout md-flex="45">
                <label for="clientId">Client Name</label>
                <model-list-select
                  :list="clientList"
                  id="clientId"
                  v-model="amsFiligModal.clientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select  Client Name"
                  isDisabled
                ></model-list-select>
              </md-layout>
            </md-layout>

            <div>
            
              <md-layout md-gutter class="mt-3">
         
                <md-layout md-flex="25">
                  <h5>
                    <b-badge>Seller/Shipper Information</b-badge>
                  </h5>
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
               
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Name</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="shipperName"
                      name="shipperName"
                      v-model="amsFiligModal.shipperName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Tel/ Fax</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="shipperTelFax"
                      name="shipperTelFax"
                      v-model="amsFiligModal.shipperTelFax"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
             
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Street Address</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="shipperAddrs"
                      name="shipperAddrs"
                      v-model="amsFiligModal.shipperAddrs"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
            
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>City / Postal Code</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="cityPostalCode"
                      name="cityPostalCode"
                      v-model="amsFiligModal.cityPostalCode"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Country</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="shipperCountry"
                      name="shipperCountry"
                      v-model="amsFiligModal.shipperCountry"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
         
              <md-layout md-gutter class="mt-3">
             
                <md-layout md-flex="35">
                    <h5>
                    <b-badge>Manufracturer( Or Suppliers) Information</b-badge>
                  </h5>
                
                </md-layout>
              </md-layout>
              <md-layout md-gutter >
              
                <md-layout md-flex="100">
                  <label for="manufracturer">Manufracturer(Suppliers)</label>
                  <model-list-select
                    :list="manufracturerList"
                    id="manufracturer"
                    v-model="amsFiligModal.manufracturer"
                    option-value="manufracturerVal"
                    option-text="manufracturerTxt"
                    placeholder="Select Manufracturer"
                    :isDisabled="amsFiligModal.blType=='liner'"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout
                gutter
                class="labelMargtop"
                v-if="amsFiligModal.manufracturer!='Others' && amsFiligModal.manufracturer!=''"
              >
             
                <md-layout md-flex="25">
                  <label>{{amsFiligModal.manufacturerLabel}}</label>
                  <quill-editor
                   style="width:100%"
                    ref="myTextEditor"
                    v-model="amsFiligModal.manufacturerAll"
                    :options="editorOption"
                  ></quill-editor>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" v-if="amsFiligModal.manufracturer=='Others'">
           
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Name</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="manuOtherName"
                      name="manuOtherName"
                      v-model="amsFiligModal.manuOtherName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" v-if="amsFiligModal.manufracturer=='Others'">
              
                <md-layout md-flex="90">
                  <md-layout md-flex="100">
                    <label>Street Address</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="manuOthersAddrs"
                      name="manuOthersAddrs"
                      v-model="amsFiligModal.manuOthersAddrs"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" v-if="amsFiligModal.manufracturer=='Others'">
            
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>City / Postal Code</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="manuOthersCityPostal"
                      name="manuOthersCityPostal"
                      v-model="amsFiligModal.manuOthersCityPostal"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Country</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="manuOthersCountrt"
                      name="manuOthersCountrt"
                      v-model="amsFiligModal.manuOthersCountrt"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Tel/ Fax</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="manuOthersTelFax"
                      name="manuOthersTelFax"
                      v-model="amsFiligModal.manuOthersTelFax"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

             
              <md-layout md-gutter class="mt-3">
             
                <md-layout md-flex="35">
                   <h5>
                    <b-badge>Importer Information</b-badge>
                  </h5>
                  
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
            
                <md-layout md-flex="30">
                  <label for="Importer">Importer</label>
                  <model-list-select
                    :list="manufracturerList"
                    id="Importer"
                    v-model="amsFiligModal.ImporterInfo"
                    option-value="manufracturerVal"
                    option-text="manufracturerTxt"
                    placeholder="Select Importer"
                    :isDisabled="amsFiligModal.blType=='liner'"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout
                gutter
                class="labelMargtop"
                v-if="amsFiligModal.ImporterInfo!='Others' && amsFiligModal.ImporterInfo!=''"
              >
            
                <md-layout md-flex="100">
                  <label>{{amsFiligModal.importerLabel}}</label>
                  <quill-editor
                  style="width:100%"
                    ref="myTextEditor"
                    v-model="amsFiligModal.importerAll"
                    :options="editorOption"
                  ></quill-editor>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" v-if="amsFiligModal.ImporterInfo=='Others'">
                
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Name</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="impOtherName"
                      name="impOtherName"
                      v-model="amsFiligModal.impOtherName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" v-if="amsFiligModal.ImporterInfo=='Others'">
           
                <md-layout md-flex="90">
                  <md-layout md-flex="100">
                    <label>Street Address</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="impOthersAddrs"
                      name="impOthersAddrs"
                      v-model="amsFiligModal.impOthersAddrs"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" v-if="amsFiligModal.ImporterInfo=='Others'">
               
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>City / Postal Code</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="impOthersCityPostal"
                      name="impOthersCityPostal"
                      v-model="amsFiligModal.impOthersCityPostal"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Country</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="impOthersCountrty"
                      name="impOthersCountry"
                      v-model="amsFiligModal.impOthersCountry"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Tel/ Fax</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="impOthersTelFax"
                      name="impOthersTelFax"
                      v-model="amsFiligModal.impOthersTelFax"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

             
              <md-layout md-gutter class="mt-3">
               
                <md-layout md-flex="35">
                    <h5>
                    <b-badge>Buyer Information</b-badge>
                  </h5>
                
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
             
                <md-layout md-flex="30">
                  <label for="Buyer">Buyer</label>
                  <model-list-select
                    :list="manufracturerList"
                    id="Buyer"
                    v-model="amsFiligModal.BuyerInfo"
                    option-value="manufracturerVal"
                    option-text="manufracturerTxt"
                    placeholder="Select Buyer"
                    :isDisabled="amsFiligModal.blType=='liner'"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout
                gutter
                class="labelMargtop"
                v-if="amsFiligModal.BuyerInfo!='Others' && amsFiligModal.BuyerInfo!=''"
              >
              
                <md-layout md-flex="25">
                  <label>{{amsFiligModal.buyerLabel}}</label>
                  <quill-editor
                   style="width:100%"
                    ref="myTextEditor"
                    v-model="amsFiligModal.buyerAll"
                    :options="editorOption"
                  ></quill-editor>
                </md-layout>
              </md-layout>
              <div v-if="amsFiligModal.BuyerInfo=='Others'">
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="35">
                    <md-layout md-flex="100">
                      <label>Name</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="buyerrName"
                        name="buyerrName"
                        v-model="amsFiligModal.buyerrName"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter class="gutr" v-if="amsFiligModal.BuyerInfo=='Others'">
               
                  <md-layout md-flex="90">
                    <md-layout md-flex="100">
                      <label>Street Address</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="buyerOthersAddrs"
                        name="buyerOthersAddrs"
                        v-model="amsFiligModal.buyerOthersAddrs"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="gutr" v-if="amsFiligModal.BuyerInfo=='Others'">
               
                  <md-layout md-flex="25">
                    <md-layout md-flex="100">
                      <label>City / Postal Code</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="buyerOthersCityPostal"
                        name="buyerOthersCityPostal"
                        v-model="amsFiligModal.buyerOthersCityPostal"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <md-layout md-flex="100">
                      <label>Country</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="buyerOthersCountry"
                        name="buyerOthersCountry"
                        v-model="amsFiligModal.buyerOthersCountry"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="30">
                    <md-layout md-flex="100">
                      <label>Tel/ Fax</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="buyerOthersTelFax"
                        name="buyerOthersTelFax"
                        v-model="amsFiligModal.buyerOthersTelFax"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </div>

            
              <md-layout md-gutter class="mt-3">
            
                <md-layout md-flex="35">
                   <h5>
                    <b-badge>Consignee Information</b-badge>
                  </h5>
                
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
             
                <md-layout md-flex="30">
                  <label for="Buyer">Consignee</label>
                  <model-list-select
                    :list="manufracturerList"
                    id="Buyer"
                    v-model="amsFiligModal.consigneeInfo"
                    option-value="manufracturerVal"
                    option-text="manufracturerTxt"
                    placeholder="Select Consignee"
                    :isDisabled="amsFiligModal.blType=='liner'"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout
                gutter
                class="labelMargtop"
                v-if="amsFiligModal.consigneeInfo!='Others' && amsFiligModal.consigneeInfo!=''"
              >
              
                <md-layout md-flex="100">
                  <label>{{amsFiligModal.consigneeLabel}}</label>
                  <quill-editor
                  style="width:100% !important"
                    ref="myTextEditor"
                    v-model="amsFiligModal.consigneeAll"
                    :options="editorOption"
                  ></quill-editor>
                </md-layout>
              </md-layout>

              <div v-if="amsFiligModal.consigneeInfo=='Others'">
                <md-layout md-gutter class="gutr">
            
                  <md-layout md-flex="35">
                    <md-layout md-flex="100">
                      <label>Name</label>
                      <b-form-input :formatter="capitalizeAll" id="conName" name="conName" v-model="amsFiligModal.conName"></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="gutr" v-if="amsFiligModal.consigneeInfo=='Others'">
               
                  <md-layout md-flex="90">
                    <md-layout md-flex="100">
                      <label>Street Address</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="consigneeOthersAddrs"
                        name="consigneeOthersAddrs"
                        v-model="amsFiligModal.consigneeOthersAddrs"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="gutr" v-if="amsFiligModal.consigneeInfo=='Others'">
                  
                  <md-layout md-flex="25">
                    <md-layout md-flex="100">
                      <label>City / Postal Code</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="consigneeOthersCityPostal"
                        name="consigneeOthersCityPostal"
                        v-model="amsFiligModal.consigneeOthersCityPostal"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <md-layout md-flex="100">
                      <label>Country</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="consigneeOthersCountry"
                        name="consigneeOthersCountry"
                        v-model="amsFiligModal.consigneeOthersCountry"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="30">
                    <md-layout md-flex="100">
                      <label>Tel/ Fax</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="consigneeOthersTelFax"
                        name="consigneeOthersTelFax"
                        v-model="amsFiligModal.consigneeOthersTelFax"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </div>
           
              <md-layout md-gutter class="mt-3">
              
                <md-layout md-flex="35">
                   <h5>
                    <b-badge>Consolidator Or Booking Agent Information</b-badge>
                  </h5>
                
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
            
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Name</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="consolidatorName"
                      name="consolidatorName"
                      v-model="amsFiligModal.consolidatorName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
            
                <md-layout md-flex="90">
                  <md-layout md-flex="100">
                    <label>Street Address</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="consolidatorAddrs"
                      name="consolidatorAddrs"
                      v-model="amsFiligModal.consolidatorAddrs"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
              
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>City / Postal Code</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="consolidatorCityPostal"
                      name="consolidatorCityPostal"
                      v-model="amsFiligModal.consolidatorCityPostal"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Country</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="consolidatorCountry"
                      name="consolidatorCountry"
                      v-model="amsFiligModal.consolidatorCountry"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Tel/ Fax</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="consolidatorTelFax"
                      name="consolidatorTelFax"
                      v-model="amsFiligModal.consolidatorTelFax"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
         
              <md-layout md-gutter class="mt-3">
              
                <md-layout md-flex="35">
                   <h5>
                    <b-badge>Container Stuffing Location Details</b-badge>
                  </h5>
                
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
             
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Name</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="consolidatorName"
                      name="consolidatorName"
                      v-model="amsFiligModal.containerStuffingName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
              
                <md-layout md-flex="90">
                  <md-layout md-flex="100">
                    <label>Street Address</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="consolidatorAddrs"
                      name="consolidatorAddrs"
                      v-model="amsFiligModal.containerStuffingAddrs"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
          
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>City / Postal Code</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="consolidatorCityPostal"
                      name="consolidatorCityPostal"
                      v-model="amsFiligModal.containerStuffingCityPostal"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Country</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="consolidatorCountry"
                      name="consolidatorCountry"
                      v-model="amsFiligModal.containerStuffingCountry"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Tel/ Fax</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="consolidatorTelFax"
                      name="consolidatorTelFax"
                      v-model="amsFiligModal.containerStuffingTelFax"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
        
              <md-layout md-gutter class="mt-3">
               
                <md-layout md-flex="35">
                      <h5>
                    <b-badge>Other Information</b-badge>
                  </h5>
               
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
              
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Country of Manufracturer</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="countryOrigin"
                      name="countryOrigin"
                      v-model="amsFiligModal.countryOrigin"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Purchase Order(PO)</label>
                    <b-form-input :formatter="capitalizeAll" id="consopo" name="consopo" v-model="amsFiligModal.consopo"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
          
                <md-layout md-flex="90">
                  <md-layout md-flex="100">
                    <label>HTS Code</label>
                    <b-form-textarea :formatter="capitalizeAll" id="htsCode" name="htsCode" v-model="amsFiligModal.htsCode"></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>

         

              <md-layout md-gutter class="mt-3">
            
                <md-layout md-flex="35">
                       <h5>
                    <b-badge>Shipping Information</b-badge>
                  </h5>
                  
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
              
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Carrier Name</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="CarrierName"
                      name="CarrierName"
                      v-model="amsFiligModal.CarrierName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Booking No.</label>
                    <b-form-input :formatter="capitalizeAll" id="bookingNo" name="bookingNo" v-model="amsFiligModal.bookingNo"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Carrier MBL SCAC Code</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="mblScacCode"
                      name="mblScacCode"
                      v-model="amsFiligModal.mblScacCode"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
            
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Master Bill of Landing</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="masterBillLanding"
                      name="masterBillLanding"
                      v-model="amsFiligModal.masterBillLanding"
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>AMS SCAC Code</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="amsScacCode"
                      name="amsScacCode"
                      v-model="amsFiligModal.amsScacCode"
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>AMS No./HBL No.</label>
                    <b-form-input :formatter="capitalizeAll" id="amsNo" name="amsNo" v-model="amsFiligModal.amsNo"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Container No.</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="containerNumber"
                      name="containerNumber"
                      v-model="amsFiligModal.containerNumber"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
               
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Vessel/Mother Vsl/Voy</label>
                    <b-form-input :formatter="capitalizeAll" id="vesselVoy" name="vesselVoy" v-model="amsFiligModal.vesselVoy"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>ETD Mother Vessel/LoadPort</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="etdloadPort"
                      name="etdloadPort"
                      v-model="amsFiligModal.etdloadPort"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>ETA at POD</label>
                    <b-form-input :formatter="capitalizeAll" id="etaPod" name="etaPod" v-model="amsFiligModal.etaPod"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr mt-3">
              
                <md-layout md-flex="20">
                  <b-button variant="primary" id="addButtonLoaderSubmit" @click="addIsf">Save &Submit</b-button>
                  <md-spinner md-indeterminate id="loaderSubmit" style="display:none"></md-spinner>
                </md-layout>
                <md-layout md-flex="20"></md-layout>
                <!-- <md-layout md-flex="20">
                  <md-button
                    v-if="amsFiligModal.normalIsfId!=''"
                    class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                    id="addButtonLoaderSub"
                    @click="downloadWord()"
                  >Download Word</md-button>
                  <md-spinner md-indeterminate id="loaderSub" style="display:none"></md-spinner>
                </md-layout>-->
              </md-layout>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="alertSubmit"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopError"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/freightForward/normalIsfExport"
      );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      docURL: URL_BASE_DOC,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      isLoading: false,

      manufracturerList: [
        {
          manufracturerVal: "ConsigneeName",
          manufracturerTxt: "Consignee Name"
        },
        {
          manufracturerVal: "FirstNotify",
          manufracturerTxt: "First Notify"
        },
        {
          manufracturerVal: "SecondNotify",
          manufracturerTxt: "Second Notify "
        },
        {
          manufracturerVal: "Others",
          manufracturerTxt: "Others"
        }
      ],
      blTypeListISF: [
        {
          blTypeIsfVal: "Yes",
          blTypeIsfTxt: "Yes"
        },
        {
          blTypeIsfVal: "No",
          blTypeIsfTxt: "No"
        }
      ],

      errorList: {
        clientId: ""
      },

      errorNames: {
        clientId: "Select Client Name To Proceed"
      },

      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      getCLientData: [],
      getContainerArry: [],
      stuffingDataLiner: [],
      ifsTableArry: [],
      normalIsfDetails: [],
      wordId: "",

      portLocationType: "",
      amsFiligModal: {
        normalIsfId: "",
        manufacturerLabel: "",
        buyerLabel: "",
        importerLabel: "",
        consigneeLabel: "",
        manufacturerAll: "",
        importerAll: "",
        buyerAll: "",
        consigneeAll: "",
        blType: this.$sessionsStorage.get("blType"),
        ffType: this.$sessionsStorage.get("ffType"),
        clientId: "",
        shipperName: "",
        shipperTelFax: "",
        shipperAddrs: "",
        cityPostalCode: "",
        shipperCountry: "",

        manufracturer: "",
        manuOtherName: "",
        manuOthersAddrs: "",
        manuOthersCityPostal: "",
        manuOthersCountrt: "",
        manuOthersTelFax: "",

        ImporterInfo: "",
        impOtherName: "",
        impOthersAddrs: "",
        impOthersCityPostal: "",
        impOthersCountry: "",
        impOthersTelFax: "",
        impOthersTelFax: "",

        BuyerInfo: "",
        buyerrName: "",
        buyerOthersAddrs: "",
        buyerOthersCityPostal: "",
        buyerOthersCountry: "",
        buyerOthersTelFax: "",

        consigneeInfo: "",
        consigneeOthersAddrs: "",
        consigneeOthersCityPostal: "",
        consigneeOthersCountry: "",
        consigneeOthersTelFax: "",

        consolidatorName: "",
        consolidatorAddrs: "",
        consolidatorCityPostal: "",
        consolidatorCountry: "",
        consolidatorTelFax: "",

        containerStuffingName: "",
        containerStuffingAddrs: "",
        containerStuffingCityPostal: "",
        containerStuffingCountry: "",
        containerStuffingTelFax: "",

        countryOrigin: "",
        consopo: "",
        htsCode: "",

        CarrierName: "",
        bookingNo: "",
        mblScacCode: "",
        masterBillLanding: "",
        amsScacCode: "",
        amsNo: "",
        containerNumber: "",
        vesselVoy: "",
        etdloadPort: "",
        etaPod: "",

        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        conFclBookingId: "",
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId")
      },

      validate: true
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  watch: {
    amsFiligModal: {
      handler: function(newVal, oldVal) {
        if (
          this.amsFiligModal.clientId != "" &&
          this.amsFiligModal.blType == "house"
        ) {
          let checkAlready = this.ifsTableArry.filter(x => {
            return x.clientId == this.amsFiligModal.clientId;
          });

          if (checkAlready.length > 0 && this.amsFiligModal.conIsfId == "") {
            this.alert.content = checkAlready[0].shipperName + " Already Exist";
            this.$refs["addPopError"].open();
            this.amsFiligModal.clientId = "";
          } else {
            let arrayClentId = this.getCLientData.filter(x => {
              return x.clientId == this.amsFiligModal.clientId;
            });

            if (arrayClentId.length > 0) {
              this.amsFiligModal.bookingNo = arrayClentId[0].bookingNo;
              this.amsFiligModal.masterBillLanding = arrayClentId[0].billLading;
              this.amsFiligModal.shipperName = arrayClentId[0].clientName;
              this.amsFiligModal.vesselVoy = arrayClentId[0].vesselVoy;

              let notifyArray = ["First", "Second", "Third", "Fourth", "Fifth"];
              let obj = {
                manufracturerTxt: "Consignee Name",
                manufracturerVal: "ConsigneeName",
                originalVal: arrayClentId[0].consignee
              };
              let arrayAll = [];
              arrayAll.push(obj);

              let notifyAr = arrayClentId[0].notifyList.split("$$$");

              notifyAr.map((x, index) => {
                let obj1 = {
                  manufracturerTxt: notifyArray[index] + " Notify",
                  manufracturerVal: notifyArray[index] + "Notify",
                  originalVal: x
                };
                arrayAll.push(obj1);
              });
              arrayAll.push({
                manufracturerTxt: "Others",
                manufracturerVal: "Others",
                originalVal: ""
              });

              this.manufracturerList = arrayAll;
            }

            if (this.amsFiligModal.manufracturer != "") {
              let arrayFilterNew = this.manufracturerList.filter(x => {
                return x.manufracturerVal == this.amsFiligModal.manufracturer;
              });

              if (arrayFilterNew.length > 0) {
                this.amsFiligModal.manufacturerLabel =
                  arrayFilterNew[0].manufracturerTxt;
              }
            }
            if (this.amsFiligModal.ImporterInfo != "") {
              let arrayFilterImp = this.manufracturerList.filter(x => {
                return x.manufracturerVal == this.amsFiligModal.ImporterInfo;
              });

              if (arrayFilterImp.length > 0) {
                this.amsFiligModal.importerLabel =
                  arrayFilterImp[0].manufracturerTxt;
              }
            }
            if (this.amsFiligModal.BuyerInfo != "") {
              let arrayFilterBuy = this.manufracturerList.filter(x => {
                return x.manufracturerVal == this.amsFiligModal.BuyerInfo;
              });

              if (arrayFilterBuy.length > 0) {
                this.amsFiligModal.buyerLabel =
                  arrayFilterBuy[0].manufracturerTxt;
              }
            }
            if (this.amsFiligModal.consigneeInfo != "") {
              let arrayFilterCon = this.manufracturerList.filter(x => {
                return x.manufracturerVal == this.amsFiligModal.consigneeInfo;
              });

              if (arrayFilterCon.length > 0) {
                this.amsFiligModal.consigneeLabel =
                  arrayFilterCon[0].manufracturerTxt;
              }
            }
            let arrayContainer = this.getContainerArry.filter(x => {
              return x.ffConExecutionId == this.amsFiligModal.ffConExecutionId;
            });

            if (arrayContainer.length > 0) {
              this.amsFiligModal.containerNumber =
                arrayContainer[0].fclConcontainerNo +
                "---" +
                arrayContainer[0].containerType;
            }
          }
        }
        if (
          this.amsFiligModal.clientId != "" &&
          this.amsFiligModal.blType == "liner"
        ) {
          let checkAlready = this.ifsTableArry.filter(x => {
            return x.clientId == this.amsFiligModal.clientId;
          });

          if (checkAlready.length > 0 && this.amsFiligModal.conIsfId == "") {
            this.alert.content = checkAlready[0].shipperName + " Already Exist";
            this.$refs["addPopError"].open();
            this.amsFiligModal.clientId = "";
          } else {
            let arrayClentIdLiner = this.getCLientData.filter(x => {
              return x.clientId == this.amsFiligModal.clientId;
            });

            if (arrayClentIdLiner.length > 0) {
              this.amsFiligModal.shipperName = arrayClentIdLiner[0].clientName;
            }

            let arrayDataOther = this.stuffingDataLiner.filter(x => {
              return (
                x.ffFclConsoExportId == this.amsFiligModal.ffFclConsoExportId
              );
            });

            if (arrayDataOther.length > 0) {
              this.amsFiligModal.bookingNo = arrayDataOther[0].bookingNumber;
            }

            let arrayContainer = this.getContainerArry.filter(x => {
              return x.ffConExecutionId == this.amsFiligModal.ffConExecutionId;
            });

            if (arrayContainer.length > 0) {
              this.amsFiligModal.containerNumber =
                arrayContainer[0].fclConcontainerNo +
                "---" +
                arrayContainer[0].containerType;
            }
          }
        }
      },

      deep: true
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent
  },

  computed: {
    clientList() {
      return this.getCLientData;
    }
  },

  methods: {
    downloadWord() {
      let id = this.wordId;
      console.log(id, "hgh");

      window.location =
        `${this.docURL}/pridelApiNew/Freight/isfWord.php?id=` + id;
      //  "http://13.229.240.246/pridelApiNew/Freight/isfWord.php?id=" + id;
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    oncloseBL() {},
    getData() {
      let new_data = {
        ffType: this.$sessionsStorage.get("ffType"),
        blType: this.$sessionsStorage.get("blType")
      };

      new_data["ffExportFclId"] = this.$sessionsStorage.get("editExportFCLId");
      new_data["ffExecutionId"] = this.$sessionsStorage.get(
        "editFFExecutionId"
      );

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToISFNormal.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            if (this.$sessionsStorage.get("blType") == "liner") {
              if (data.normalIsfData.length > 0) {
                Object.keys(this.amsFiligModal).map((x, index) => {
                  this.amsFiligModal[x] = data.normalIsfData[0][x] || "";
                });
              }
              this.amsFiligModal.manufracturer = "Others";
              this.amsFiligModal.ImporterInfo = "Others";
              this.amsFiligModal.BuyerInfo = "Others";
              this.amsFiligModal.consigneeInfo = "Others";

              if (data.blLandingDataLiner.length > 0) {
                this.getCLientData = data.blLandingDataLiner;
              } else {
                this.getCLientData = [];
              }
              if (this.getCLientData.length > 0) {
                this.amsFiligModal.clientId = this.getCLientData[0].clientId;
              }
            }
            if (this.$sessionsStorage.get("blType") == "house") {
              if (data.normalIsfData.length > 0) {
                Object.keys(this.amsFiligModal).map((x, index) => {
                  this.amsFiligModal[x] = data.normalIsfData[0][x] || "";
                });
              }
              if (data.normalIsfData.length > 0) {
                this.wordId = data.normalIsfData[0].normalIsfId;
              }
              if (data.BLDataISF.length > 0) {
                this.getCLientData = data.BLDataISF;
                this.portLocationType = data.BLDataISF[0].portLocationType;
              } else {
                this.getCLientData = [];
              }
              if (this.getCLientData.length > 0) {
                this.amsFiligModal.clientId = this.getCLientData[0].clientId;
              }
            }

            if (data.stuffingData.length > 0) {
              this.stuffingDataLiner = data.stuffingData;

              this.portLocationType = data.stuffingData[0].portLocationType;
              this.amsFiligModal.clientId = data.stuffingData[0].clientId;
            } else {
              this.stuffingDataLiner = [];
            }
            if (data.conIsfData.length > 0) {
              this.ifsTableArry = data.conIsfData;
            } else {
              this.ifsTableArry = [];
            }

            this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    viewEditIsf(item) {
      Object.keys(this.amsFiligModal).map((x, index) => {
        this.amsFiligModal[x] = data.normalIsfData[x];
      });
    },

    addIsf() {
      this.amsFiligModal["ffType"] = this.$sessionsStorage.get("ffType");
      this.amsFiligModal["blType"] = this.$sessionsStorage.get("blType");

      this.amsFiligModal["ffExportFclId"] = this.$sessionsStorage.get(
        "editExportFCLId"
      );
      this.amsFiligModal["ffExecutionId"] = this.$sessionsStorage.get(
        "editFFExecutionId"
      );

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addNormalIsf.php`,
          data: JSON.stringify(this.amsFiligModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");

              if (this.amsFiligModal.normalIsfId != "") {
                this.alert.content = "Data updated Successfully";
                this.$refs["alertSubmit"].open();
              } else {
                this.alert.content = "Data Added Successfully";
                this.$refs["alertSubmit"].open();
              }

              this.getData();
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },

    previousams() {
window.history.go(-1)
      // this.$router.push({
      //   path: "/freightForwarding/amsFilingNormal"
      // });
    }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// normalIsfExport.vue?698a5144